import { createTheme as o } from "../../_mixins/use-theme.js";
import n from "../../_styles/common/light.js";
import r from "../../_internal/selection/styles/light.js";
import m from "../../_internal/select-menu/styles/light.js";
function c(e) {
  const {
    boxShadow2: t
  } = e;
  return {
    menuBoxShadow: t
  };
}
const i = o({
  name: "Select",
  common: n,
  peers: {
    InternalSelection: r,
    InternalSelectMenu: m
  },
  self: c
}), f = i;
export {
  f as default,
  c as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/select/styles/light.js
// module id = 932
// module chunks = 41